<h1 mat-dialog-title><strong>File Upload</strong></h1>
<div mat-dialog-content style="overflow-x:hidden;text-align:center;">
  <input #fileInput type="file" accept=".xlsx" (change)="UploadFile($event);" style="display:none;" />
  <button mat-raised-button color="primary" style="width:10em;height:3em" (click)="fileInput.click()">Choose a File</button>
  <p style="font-size:13px;">{{fileName || "File must be .xlsx"}}</p>
</div>
<div mat-dialog-actions [align]="'end'">
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="!canUpload" [mat-dialog-close]="data" cdkFocusInitial>Upload</button>
</div>
